import { DataPrepReadableConsts } from 'dashboard-services/api/dataPrep';
import { DataStorageEnums } from 'dashboard-services/api/dataStorage';
import { ActionService } from 'dashboard-services/services';
import TimeService from 'dashboard-services/services/TimeService';

import properties from 'resources/constants/properties.json';
import { routing } from 'routing';

import { builderDataStorageCreatorActions, saveDialogDataStorageCreatorActions } from './';

const SYMBOLS_SIZE_BASKET_SWITCH = 30
export default (() => {

  const CHANGE_VALUE = 'CHANGE_VALUE_BASIC_CREATOR_DATA_STORAGE'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'value', 'name')

  const init = ({ dataPrep: response, navigate }) => dispatch => {
    clear()
    const initConfigObj = {
      dataRange: response.range,
      lastTypeOnTimeTimezone: response.lastTypeOnTimeTimezone,
      holidayCalendar: response.holidayCalendar,
      lastTypeOnTime: response.lastTypeOnTime,
      lastValue: response.lastTypeAmount,
      lastType: response.lastType,
      deltaTransDateLimitType: response.deltaTransDateLimitType,
      deltaTransDateLimitAmount: response.deltaTransDateLimitAmount,
      decimalPlaces: response.decimalPrecision,
      skipEmptyColumns: response.skipEmptyColumns,
      delta: response.delta,
      outputLayout: response.outputLayout || DataPrepReadableConsts.OUTPUT_LAYOUTS[1],
      withType: response.withType,
      attachMetadataToNcsv: response.attachMetadataToNcsv === null || response.attachMetadataToNcsv === undefined ? properties.attachMetadataToNcsv === 'true' : response.attachMetadataToNcsv,
      failOnMissingSymbols: response.failOnMissingSymbols,
      ncsvEmptySymbolsInResult: response.ncsvEmptySymbolsInResult,
      dateFormat: response.dateFormat || TimeService.BACKEND_ISO_DATE_TIME_FORMAT,
      timezone: response.timezone || undefined,
      roundingMode: response.roundingMode || "HALF_UP",
      corrections: response.corrections || "false",
      order: response.order,
      withWareHouseService: response.source === "WarehouseService" ? true : false
    }
    if(response.range === DataStorageEnums.DATA_RANGE.LAST || response.range === DataStorageEnums.DATA_RANGE.NEXT) {
      initConfigObj.order = "DESC"
    }
    if (Object.values(DataStorageEnums.DATE_BETWEEN_TYPE).includes(response.dateFrom)) {
      initConfigObj.fromSelected = response.dateFrom
    } else {
      initConfigObj.fromSelected = DataStorageEnums.DATE_BETWEEN_TYPE.DATE
      initConfigObj.from = response.dateFrom ? TimeService.getUserFormattedDate(Number(response.dateFrom), response.timezone || "UTC") : response.dateFrom
      initConfigObj.fromTime = response.dateFrom ? TimeService.getUserFormattedTime(Number(response.dateFrom), response.timezone || "UTC") : response.dateFrom
    }
    if (Object.values(DataStorageEnums.DATE_BETWEEN_TYPE).includes(response.dateTo)) {
      initConfigObj.toSelected = response.dateTo
      dispatch(builderDataStorageCreatorActions.changeValue(response.dateTo, 'toSelected'))
    } else {
      initConfigObj.toSelected = DataStorageEnums.DATE_BETWEEN_TYPE.DATE
      initConfigObj.to = response.dateTo ? TimeService.getUserFormattedDate(Number(response.dateTo), response.timezone || "UTC") : response.dateTo
      initConfigObj.toTime = response.dateTo ? TimeService.getUserFormattedTime(Number(response.dateTo), response.timezone || "UTC") : response.dateTo
    }
    initConfigObj.basket = []
    let longestGroup = 0;
    response.symbols.forEach((item, index) => {
      if(item?.groupName && item.groupName.length > longestGroup) {
        longestGroup = item.groupName.length
      }
      initConfigObj.basket.push(Object.assign({}, item, {
        choosenColumns: item.valueColumnNames.map(i => ({ value: i, label: i === "*" ? "All" : i })),
        index,
        values: item.valueColumnName ? [item.valueColumnName] : item.valueColumnNames,
        symbols: item.symbol
      }))
    })
    if(response.dataGroupName) {
      initConfigObj.basket = [{
        groupName: response.dataGroupName,
        pattern: true,
        choosenColumns: [{
          value: "*",
          label: "All"
        }]
      }]
    }
    Object.entries(initConfigObj).forEach(([k, v]) => dispatch(builderDataStorageCreatorActions.changeValue(v, k)))
    dispatch(builderDataStorageCreatorActions.changeValue(builderDataStorageCreatorActions.getGroupWidth(longestGroup), 'basketLongestGroup'))
    dispatch(builderDataStorageCreatorActions.changeValue(initConfigObj, 'initConfigObj'))
    dispatch(changeValue(response.id, 'id'))
    dispatch(saveDialogDataStorageCreatorActions.changeValue(response.name, 'name'))
    dispatch(saveDialogDataStorageCreatorActions.changeValue(response.outputGroup, 'groupName'))
    if (response.symbols.length > SYMBOLS_SIZE_BASKET_SWITCH) {
      navigate(`${window.location.search}#${routing.dataStorage.routing.creator.hashes.basket}`)
    }
    dispatch(changeValue(true, 'saved'))
  }
  
  const CLEAR = 'CLEAR_BASIC_CREATOR_DATA_STORAGE'
  const clear = ActionService.makeActionCreator(CLEAR)

  const BRING_TO_FRONT = 'BRING_TO_FRONT_BASIC_CREATOR_DATA_STORAGE'
  const bringToFront = ActionService.makeActionCreator(BRING_TO_FRONT, 'value')

  const compareWithInitialState = () => (_, getState) => {
    const initConfigObj = getState().dataStorageState.creatorState.builderState.initConfigObj,
          builderState = getState().dataStorageState.creatorState.builderState
    let isSame = true
    Object.entries(initConfigObj || {}).forEach(([k, v]) => {
      if(typeof v === 'object') {
        if(JSON.stringify(v) !== JSON.stringify(builderState[k])) {
          isSame = false;
        }
      } else {
        if(String(v) !== String(builderState[k])) {
          isSame = false
        }
      }
    })

    return isSame
  }

  return {
    changeValue,
    CHANGE_VALUE,
    clear,
    CLEAR,
    bringToFront,
    BRING_TO_FRONT,
    init,
    compareWithInitialState
  }
})()
